import KLINE from './series/KLINE';
import MA from './series/MA';
import BOLL from './series/BOLL';
import PRESSURELINE from './series/PRESSURELINE';
import VOLUME from './series/VOLUME';
import NETFLOW from './series/NETFLOW';
import ABNORMALVOLUME from './series/ABNORMALVOLUME';
import RSI from './series/RSI';
import KDJ from './series/KDJ';
import MACD from './series/MACD';
import MARKPOINT from './series/MARKPOINT';

/**
 * KLineGenerateSeriesController类定义
 */
class KLineGenerateSeriesController {
    /**
     * KLineGenerateSeriesController类构造函数
     * @param {Object} markPointOption MarkPoint选项
     */
    constructor(markPointOption) {
        this.markPointOption = markPointOption;

        this.chartDatas = []; // 开盘价，收盘价，最低价，最高价
        this.times = [];
        this.opens = [];
        this.closes = [];
        this.lowests = [];
        this.highests = [];
        this.vols = [];
        this.pressureLineDatas = [];
        this.netFlowDatas = [];
        this.markPointData = {};

        this.kline = null;
        this.ma = null;
        this.boll = null;
        this.pressureLine = null;
        this.netFlow = null;
        this.abnormalVolume = null;
        this.volume = null;
        this.macd = null;
        this.rsi = null;
        this.kdj = null;
        this.markPoint = null;
    }

    /**
     * 给所有属性赋初始值
     * @param {Object} dataObj 服务器端返回的数据对象
     */
    initDataProperty(dataObj) {
        Object.keys(this).forEach(key => {
            if (key === 'markPointOption') {
                return;
            }

            if (this[key] instanceof Array) {
                this[key] = [];
            } else if (key === 'markPointData') {
                this[key] = {};
            } else {
                this[key] = null;
            }
        });

        if (!dataObj) {
            return;
        }

        // 给chartDatas、times、opens、close、lowest、highest和vols赋值
        let klineObj = dataObj.kline;
        for (const key in klineObj) {
            if (this.hasOwnProperty(key)) {
                const value = klineObj[key];
                this[key] = value;
            }
        }
        this.pressureLineDatas = klineObj.pressureline;
        this.netFlowDatas = klineObj.netflow;
        this.markPointData = dataObj.markPoint;
    }

    /**
     * 生成series选项
     * @param {String} seriesName series名称
     * @param {Array<String>} showMarkPointTypes 要显示的MarkPoint类型
     * @returns {Object} 返回生成的series选项
     */
    generateSeriesOption(seriesName, showMarkPointTypes) {
        let option = {};
        switch (seriesName) {
            case 'KLINE':
                // 因为是否显示实时解盘是由用户决定的(不能把series里markPoint的data置空，因为还要添加一些固定点，比如：最大值、最小值等)，
                // 所以每次都需要重新计算，并生成option
                if (!this.kline) {
                    this.kline = new KLINE(this.chartDatas);
                }
                option = this.kline.generateSeriesOption();

                if (!this.markPoint) {
                    this.markPoint = new MARKPOINT(
                        this.markPointOption,
                        this.markPointData,
                        this.times,
                        this.chartDatas
                    );
                }
                option.markPoint.data = this.markPoint.generateMarkPointOption(showMarkPointTypes);
                break;
            case 'MA':
                if (!this.ma) {
                    this.ma = new MA(this.closes);
                    this.ma.calculate();
                }
                option = this.ma.generateSeriesOption();
                break;
            case 'BOLL':
                if (!this.boll) {
                    this.boll = new BOLL(this.closes);
                    this.boll.calculate();
                }
                option = this.boll.generateSeriesOption();
                break;
            case 'PRESSURELINE':
                if (!this.pressureLine) {
                    this.pressureLine = new PRESSURELINE(this.pressureLineDatas);
                }
                option = this.pressureLine.generateSeriesOption();
                break;
            case 'VOL':
                if (!this.volume) {
                    this.volume = new VOLUME(this.vols, this.chartDatas);
                }
                option = this.volume.generateSeriesOption();
                break;
            case 'NETFLOW':
                if (!this.netFlow) {
                    this.netFlow = new NETFLOW(this.netFlowDatas);
                }
                option = this.netFlow.generateSeriesOption();
                break;
            case 'ABNORMALVOLUME': // 异常交易成交量(ABNORMALTRANSACTION也得存在)
                if (!this.abnormalVolume) {
                    this.abnormalVolume = new ABNORMALVOLUME(this.markPointData.abnormaltransaction, this.times);
                    this.abnormalVolume.calculate();
                }
                option = this.abnormalVolume.generateSeriesOption();
                break;
            case 'RSI':
                if (!this.rsi) {
                    this.rsi = new RSI(this.closes);
                    this.rsi.calculate();
                }
                option = this.rsi.generateSeriesOption();
                break;
            case 'KDJ':
                if (!this.kdj) {
                    this.kdj = new KDJ(this.closes, this.lowests, this.highests);
                    this.kdj.calculate();
                }
                option = this.kdj.generateSeriesOption();
                break;
            case 'MACD':
                if (!this.macd) {
                    this.macd = new MACD(this.closes);
                    this.macd.calculate();
                }
                option = this.macd.generateSeriesOption();
                break;
        }

        return option;
    }
}

export default KLineGenerateSeriesController;



// WEBPACK FOOTER //
// ./src/controller/KLineGenerateSeries.js